<template>
    <div class="sidebar" :class="[{ opened: showSidebar }]">
        <div class="sidebar__inner d-flex flex-column justify-content-between">
            <div>
                <div
                    class="segment d-flex align-items-center"
                    style="height: 100px"
                >
                    <div class="flex-fill">
                        <h1>Hammer</h1>
                    </div>
                    <div class="text-center" style="width: 60px">
                        <svg class="sidebar__close" @click="closesidebar()">
                            <use
                                :xlink:href="`${icons['chevron-left-small']}#icon`"
                            ></use>
                        </svg>
                    </div>
                </div>
                <div class="segment" v-show="showPois && isMobile">
                    <div class="segment__inner">
                        <quick-filters
                            @selectprimaryfilter="passFilter"
                            :selectedPrimaryFilter="selectedPrimaryFilter"
                        ></quick-filters>
                    </div>
                </div>
                <div class="segment">
                    <div class="segment__inner">
                        <input-radio
                            v-for="(filter, filterKey) in localSettings.routing"
                            :key="filterKey"
                            groupKey="routing"
                            :filterKey="filterKey"
                            :state="filter.value"
                            @change="changeRadioValues"
                            v-model="filter.value"
                        >
                            {{ filter.label }}
                        </input-radio>
                    </div>
                </div>
                <div class="segment">
                    <div class="segment__inner">
                        <on-off
                            v-for="(filter, filterKey) in localSettings.avoid"
                            :key="filterKey"
                            :state="filter.value"
                            v-model="filter.value"
                            @input="
                                trackGoogle('MENU_ROUTING_AVOID', filterKey)
                            "
                        >
                            {{ filter.label }}
                        </on-off>
                    </div>
                </div>
                <div class="segment">
                    <div class="segment__inner">
                        <router-link
                            :to="{ name: 'feedback' }"
                            class="link--menu"
                            @click.native="trackGoogle('MENU_FEEDBACK')"
                        >
                            <svg>
                                <use
                                    :xlink:href="`${icons['help']}#icon`"
                                ></use>
                            </svg>
                            Send feedback
                        </router-link>
                    </div>
                </div>
                <div class="segment" style="border-bottom: 0">
                    <div class="segment__inner--sub">
                        <a
                            :href="url('legal/eula')"
                            target="_blank"
                            class="link--menu"
                            @click="trackGoogle('MENU_EULA')"
                        >
                            <span
                                style="
                                    width: 24px;
                                    height: 24px;
                                    margin-right: 21px;
                                    display: inline-block;
                                "
                            >
                            </span>
                            EULA
                        </a>
                    </div>
                    <div class="segment__inner--sub">
                        <a
                            :href="url('legal/privacy')"
                            target="_blank"
                            class="link--menu"
                            @click="trackGoogle('MENU_POLICY')"
                        >
                            <span
                                style="
                                    width: 24px;
                                    height: 24px;
                                    margin-right: 21px;
                                    display: inline-block;
                                "
                            >
                            </span>
                            Privacy policies
                        </a>
                    </div>
                    <!-- <div class="segment__inner--sub">
                        <router-link
                            :to="{ name: 'licenses' }"
                            class="link--menu"
                        >
                            <span
                                style="
                                    width: 24px;
                                    height: 24px;
                                    margin-right: 21px;
                                    display: inline-block;
                                "
                            >
                            </span>
                            Licenses
                        </router-link>
                    </div> -->
                </div>
            </div>
            <div class="sidebar__footer mt-2">
                <div class="text-center">
                    <div>
                        <img
                            :src="assetUrl('images/logo.svg')"
                            alt="Hammer: Truck GPS Navigation"
                            title="For professional truck drivers"
                            width="64"
                            height="64"
                        />
                    </div>
                    <div>Version 1.0</div>
                    <div class="muted mt-5 mb-4">
                        Copyright &copy; 2021 TruckersReport.com
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showSidebar: {
            type: Boolean,
            default: false,
        },
        settings: {
            type: Object,
            default() {
                return {
                    routing: {
                        fastest: true,
                        balanced: false,
                    },
                    avoid: {
                        ferries: true,
                        tolls: true,
                    },
                };
            },
        },
        selectedPrimaryFilter: {
            default: null,
        },
        showPois: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            icons: window.here.icons,
            localSettings: this.settings,
        };
    },
    methods: {
        closesidebar() {
            this.$emit('closesidebar');
        },
        passFilter(filter) {
            this.$emit('selectprimaryfilter', filter);
        },
        changeRadioValues(val) {
            const filters = this.localSettings[val.group];
            Object.keys(filters).forEach((key) => {
                if (key !== val.filter) {
                    this.localSettings[val.group][key].value = false;
                }
            });
            if (filters.balanced.value) {
                this.trackGoogle('MENU_ROUTING_BALANCED');
            }
            if (filters.fastest.value) {
                this.trackGoogle('MENU_ROUTING_FASTEST');
            }
        },
        trackGoogle(event, tag = null) {
            this.$gtag.event(event, {
                event_category: 'MENU',
                value: tag,
            });
        },
    },
};
</script>

<style lang="scss">
.sidebar__inner {
    position: relative;
    background: #fff;
    width: 318px;
    height: 100vh;
    // box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.08);
    border-radius: 0 4px 4px 0;
    z-index: 6;

    @media screen and (max-width: 768px) {
        height: auto;
        padding-bottom: 20px;
    }
}

.sidebar__overlay {
    background-color: rgba(0, 0, 0, 0.55);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;
    width: 100vw;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.5s;

    &.opened {
        opacity: 1;
        pointer-events: all;
    }
}

.sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 13;
    height: 100vh;
    transform: translateX(-100%);
    transition: all 0.5s ease;

    @media screen and (max-width: 768px) {
        height: calc(var(--vh, 1vh) * 100);
    }

    &.opened {
        transform: translateX(0%);
        overflow-y: auto;
        background-color: #fff;
    }

    h1 {
        font-size: 32px;
        font-weight: 600;
        line-height: 40px;
        padding-left: 40px;
        color: #4e3a30;
    }

    .segment {
        border-bottom: 1px solid rgba(78, 58, 48, 0.2);

        .segment__inner {
            padding: 20px;

            p {
                margin-bottom: 0;
            }
        }

        .segment__inner--sub {
            padding: 17px;

            p {
                margin-bottom: 0;
            }
        }

        .on-off,
        .radio {
            & + .on-off,
            & + .radio {
                margin-top: 25px;
            }
        }
    }
}

.sidebar__close {
    width: 24px;
    height: 24px;
    color: rgba(78, 58, 48, 0.6);
    transition: color 0.3s;
    cursor: pointer;

    &:hover {
        color: rgba(78, 58, 48, 1);
    }
}

.link--menu {
    color: #4e3a30;
    font-size: 18px;
    font-weight: 500;

    svg {
        color: #c8532b;
        width: 24px;
        height: 24px;
        margin-right: 21px;
    }

    &:hover {
        text-decoration: none;
        color: #c8532b;
    }

    &.sub {
        margin-top: -3px;
        margin-bottom: -3px;
    }
}

.sidebar__footer {
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
    color: #4e3a30;
    background-color: #fff;

    @media screen and (max-width: 768px) {
        margin-top: 20px;
        position: static;
    }

    img {
        margin-bottom: 20px;
    }

    .muted {
        color: rgba(78, 58, 48, 0.6);
    }
}
</style>
